export default `
<div class="alert-wrapper" ng-show="message" >
  <div class="alert alert-form" ng-class="'alert-' + type" >
    <a ng-click="close()" class="close">&times;</a>
    <span ng-bind-html="message" ></span>
  </div>
</div>
`;
